import { render, staticRenderFns } from "./form.html?vue&type=template&id=71f02cbb&"
import script from "./EditStudy.vue?vue&type=script&lang=js&"
export * from "./EditStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports